import { getLocalizedMeta } from '@/utils/common'

const Layout = () => import('@/layout/index.vue')

export default {
  name: 'Viaim',
  path: '/:language?/viaimai',
  component: Layout,
  redirect: '/viaimai/index',
  children: [
    {
      name: 'ViaimaiIndex',
      path: 'index',
      component: () => import('@/views/viaimai/Index.vue'),
      meta: {
        hideTab: false,
        menu: 'Viaimai',
        ...getLocalizedMeta('viaimAi')
      }
    }
  ]
}
